<template>
    <div class="question">
        <div class="row">
            <div class="col">
                <div class="row">
                    <div class="col">
                        <Progress></Progress>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <h1>Q{{questionNumber}}. {{question.question}}</h1>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <div class="form">
                            <div class="pretty-radio">
                                <div class="answer" v-for="answer in question.answers" :key="answer.value">
                                    <label :for="answer.value" class="label label--radio">
                                        <input type="radio"
                                               v-model="selectedAnswer"
                                               :id="answer.value"
                                               :name="questionNumber"
                                               :value="answer.value"
                                               class="input input--radio"
                                               :ref="'selector'"
                                               @change="answerIntercept(answer)"/>
                                        <span class="pretty-radio__check">{{answer.answer}}</span>
                                    </label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <NavButtons :back="goBack" :answer="selectedAnswer" @sent="clear"></NavButtons>
                    </div>
                </div>
                <b-modal v-if="questionNumber === 1" id="modal-1" ref="modal-1" centered>
                    <template slot="modal-header" slot-scope="{ close }">
                        <!-- Emulate built in modal header close button action -->
                        <div class="x-close" data-dismiss="modal" aria-label="Close" @click="close()">
                            <span class="x-line x-line--one"></span>
                            <span class="x-line x-line--two"></span>
                        </div>
                    </template>
                    <p class="paragraph">You have selected 1-2 vehicles and as such this readiness tool may not be
                        appropriate
                        for your needs. You may like to take a look at our EV-4-ME? tool to discover the most
                        appropriate fuel type for your vehicles.</p>
                    <template slot="modal-footer" slot-scope="{ cancel }">
                        <!-- Emulate built in modal footer ok and cancel button actions -->
                        <a href="https://www.vwfsfleet.co.uk/electric-vs-petrol-car-advisor/" class="button button--ghost-white" target="_blank">
                            Visit the EV-4-ME? Tool
                        </a>
                        <button class="button button--solid" @click="cancel()">
                            Continue Questions
                        </button>

                    </template>
                </b-modal>
            </div>
        </div>
    </div>
</template>

<script>
    import NavButtons from './partials/NavButtons'
    import Progress from './partials/Progress'
    import BModal from 'bootstrap-vue/es/components/modal/modal'
    import VueScrollTo from 'vue-scrollto'
    export default {
        name: "Question",
        components: {
            NavButtons,
            Progress,
            BModal
        },
        data() {
            return {
                goBack: true,
            }
        },
        methods: {
            clear() {
                this.selectedAnswer = null;
            },
            answerIntercept(answer) {
                if (answer.triggers !== null) {
                    this.$refs[answer.triggers].show();
                }
            },
            next() {
                if (this.currentPage) {
                    this.$gtag.logStep(
                        'Question',
                        'EV Maturity Tool - ' + this.currentPage
                    );
                    this.$store.dispatch('next');
                    this.$emit('sent');
                    VueScrollTo.scrollTo('#app', 1);
                }
            },
        },
        computed: {
            question() {
                return this.$store.getters.getCurrentQuestion;
            },
            questionNumber() {
                return (typeof this.$store.state.current == 'number') ? this.$store.state.current : null;
            },
            selectedAnswer: {
                get: function() {
                    return this.$store.getters.getSelectedAnswer;
                },
                set: function(value) {
                    if(value !== null) {
                        this.$store.commit('setAnswer', value);
                    }
                }
            },
            currentPage: function() {
                return this.$store.state.current;
            }
        },
        watch: {
            selectedAnswer() {
                let app = this;
                this.$refs.selector.forEach(function(val){
                    val.checked = (val.value === app.selectedAnswer);
                });
            }
        }
    }
</script>

<style lang="stylus">
    .question
        .form
            .pretty-radio
                flex 0 0 100%
                display flex
                justify-items flex-start
                flex-direction column
                @media (max-width 767px)
                    flex-wrap wrap

                &__title
                    margin-right 1.5rem

                    @media (max-width 767px)
                        flex 0 0 100%
                        margin-bottom 5px


                .label--radio
                    flex 0 0 auto
                    max-width unset
                    display flex
                    position relative
                    overflow hidden
                    flex-direction row
                    justify-items flex-start
                    align-items center
                    padding-left 3.5rem
                    padding-right 0
                    cursor pointer

                    &:not(:last-child)
                        margin-right 1.5rem

                    .input
                        position absolute
                        left -9999em
                        max-width auto
                        width auto

                    // check markers

                    span
                        &:before
                            display block
                            position absolute
                            left 0
                            top 50%
                            transform translateY(-50%)
                            content ''
                            width 2.4rem
                            height 2.4rem
                            border solid 1px #a8adb3
                            box-shadow none
                            border-radius 50%
                            cursor pointer

                    .input:checked + span
                        &:after
                            display block
                            position absolute
                            left 5px
                            top 50%
                            transform translateY(-50%)
                            content ''
                            width 1.4rem
                            height 1.4rem
                            box-shadow none
                            background-color $color-blue-petrol
                            border-radius 50%
                            cursor pointer
            .label
                    margin-bottom 1.5rem


    .modal-header
        border-bottom: none !important
        justify-content flex-end !important

        .x-close
            position relative
            display block
            width 1.85rem
            height 1.85rem
            margin 0.5rem

            .x-line
                width 140%
                height 0.1rem
                border 0.1rem solid $color-grey-border
                position absolute
                top 0
                left 0

                &--one
                    transform translate(-16%, 350%) rotate(45deg)

                &--two
                    transform translate(-16%, 350%) rotate(-45 deg)

    .modal-footer
        border-top: none
        justify-content center
        margin-bottom 2rem

        .button
            padding 1.5rem 2rem 1.3rem

            &:not(:last-child)
                margin-right 2rem

    .modal-body
        padding 1rem 4rem
        text-align center
</style>